import { forwardRef, useContext } from 'react'
import { ButtonBase, ButtonBaseProps, Chip, CircularProgress } from '@mui/material'

import { AppContext } from '../../../../providers/app-provider'
import AccountsContext from '../../context'
import useStyles from '../../index.styles'

const TabButton = forwardRef((props: ButtonBaseProps, ref: React.ForwardedRef<HTMLButtonElement | null>) => {
  const classes = useStyles
  const { folder, alerts, isLoadingAlerts } = useContext(AccountsContext)
  const { tree } = useContext(AppContext)

  if (folder) {
    let count: string | number = 0
    switch (props.id) {
      case 'tab-accounts':
        count = (tree && tree[folder.id] && (tree[folder.id].children || []).length) ?? 0
        break
      case 'tab-devices':
        count = folder.deviceCount
        break
      case 'tab-contacts':
        count = folder.usercount
        break
      case 'tab-orders':
        count = folder.orderCount
        break
      case 'tab-alerts':
        count = alerts.length
        break
      default:
        count = 0
    }

    return (
      <ButtonBase {...props} ref={ref} data-testid="tab-button">
        {props.children}
        {props.id === 'tab-alerts' && isLoadingAlerts ? (
          <CircularProgress sx={classes.tabButtonSpinner} size={11} />
        ) : (
          <Chip label={count} size="small" sx={classes.tabChip} />
        )}
      </ButtonBase>
    )
  }
  return null
})

export default TabButton
